const importMetaEnv = import.meta.env;

export const env = Object.freeze({
  apiUrl: importMetaEnv.VITE_API_URL,
  sentryDsn: importMetaEnv.VITE_SENTRY_DSN as string,
  internalSecret: importMetaEnv.VITE_INTERNAL_SECRET,
  hypercardAuthorization: importMetaEnv.VITE_HYPERCARD_AUTHORIZATION,
  authRedirectUri: importMetaEnv.VITE_AUTH_REDIRECT_URI,
  postHogKey: importMetaEnv.VITE_POSTHOG_KEY,
  postHogHost: importMetaEnv.VITE_POSTHOG_HOST,
  stage: import.meta.env.VITE_STAGE,
  airWallexClientId: import.meta.env.VITE_AIRWALLEX_CLIENT_ID,
  assetsUrl:
    import.meta.env.VITE_STAGE == "development"
      ? "https://assets.development.hypercard.com"
      : "https://assets.hypercard.com",
});

export const isDevelopment = env.stage === "development";
